import AddElementBottomBar from "./AddElementBottomBar";
import { useElementMediaDropzone } from "./element-list-hooks";
import ElementsList, {
  MediaUploadDragHover,
  MediaUploadingIndicator,
} from "./ElementsList";

export default function ElementsListTab() {
  const sceneType = "mainScene";

  const { getRootProps, isDragActive, getInputProps, open, isUploadingMedia } =
    useElementMediaDropzone(sceneType);

  return (
    <div className="relative flex h-full w-full flex-col" {...getRootProps()}>
      <div className="flex-1 overflow-y-auto">
        <ElementsList sceneType={sceneType} />
      </div>
      <AddElementBottomBar
        getInputProps={getInputProps}
        open={open}
        sceneType={sceneType}
      />
      {isDragActive && <MediaUploadDragHover />}
      {isUploadingMedia && <MediaUploadingIndicator />}
    </div>
  );
}
